module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightSemiExt.d729957.woff";